import * as yup from 'yup';
import { TFunction } from 'i18next';
import { EReviewStatus } from 'libs/pinnacle-sdk';

export const getValidationSchema = () =>
  yup.object().shape({
    underwritingNotes: yup.string().nullable(),
    reviewStatus: yup.string().nullable(),
    peerReviewNotes: yup.string().nullable(),
    approvedDate: yup.date().nullable(),
  });

export const initialValues = {
  underwritingNotes: undefined,
  reviewStatus: undefined,
  peerReviewNotes: undefined,
  approvedDate: undefined,
};

export const fields = Object.keys(
  initialValues
) as (keyof typeof initialValues)[];

export const getReviewStatusOptions = (t: TFunction) => [
  {
    value: EReviewStatus.Approved,
    label: t('peerReview.reviewStatusOptions.approved'),
  },
  {
    value: EReviewStatus.ApprovedWithUpdates,
    label: t('peerReview.reviewStatusOptions.approvedWithUpdates'),
  },
  {
    value: EReviewStatus.NotApproved,
    label: t('peerReview.reviewStatusOptions.notApproved'),
  },
  {
    value: EReviewStatus.ReferToBinder,
    label: t('peerReview.reviewStatusOptions.referToBinder'),
  },
];
